/* globals axios hashToPoll location grecaptcha */

import '@babel/polyfill'
require('./bootstrap')

// const toggleCookie = document.getElementById('cookie-notice')
// toggleCookie && toggleCookie.

const checkQuickscanStatus = (hash) => {
  axios.get('/api/quickscan', {
    params: {
      scan: hash
    },
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    }
  })
    .then((response) => {
      if (response.status === 200) {
        if (response.data.status === 'FINISHED') {
          location.reload()
        } else if (response.data.status === 'FAILED') {
          location.reload()
        } else if (response.data.status === 'IN_QUEUE') {
          document.getElementById('scan-in-queue').style = 'display:block'
          document.getElementById('scan-in-progress').style = 'display:none'
        } else if (response.data.status === 'IN_PROGRESS') {
          document.getElementById('scan-in-queue').style = 'display:none'
          document.getElementById('scan-in-progress').style = 'display:block'
        }
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

const pollForQuickscanChange = (hash) => {
  const interval = setInterval(() => {
    checkQuickscanStatus(hash)
  }, 2500)
  console.log(interval)
}

typeof hashToPoll !== 'undefined' && hashToPoll && pollForQuickscanChange(hashToPoll)

const cookieOpenButtons = document.querySelectorAll('.js-toggle-cookie')
cookieOpenButtons && cookieOpenButtons.forEach((button, i) => {
  button.addEventListener('click', (e) => {
    e.preventDefault()
    document.getElementById('cookie-notice').style = 'display:block;';

    document.querySelector('.cookie-notice__title').focus();

    return false;
  })
})
